import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWSL3 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Arsenal Add Swedish Teenager",
            author: "footballgirl",
            date: "January 6, 2025",
            image: "images/wsl/3a.jpg",
            content: `<p>Arsenal have announced the signing of Swedish teenager Smilla Holmberg from Hammarby to bolster their academy and first-team options. The move signals the Gunners' intent to invest in long-term talent.</p> <p>Swedish teenager Smilla Holmberg has called her move to Arsenal "a dream come true" after putting pen to paper on a long-term contract with the club.
The 19-year-old right-back arrives from Swedish side Hammarby IF, where she rose through the academy ranks and made her senior debut at the remarkably young age of 15.

<p>Since then, she has amassed significant experience, including winning the Swedish league title in 2023 and the Swedish Cup in both 2023 and 2025, while earning nine caps for the Sweden national team.
Speaking to Arsenal's official website after signing and being assigned the No. 31 shirt, Holmberg explained her decision to make the switch to the Women's Super League:</p>
<p>"I felt the time was right to challenge myself and step outside my comfort zone."</p>

<p>She added that her initial conversations with Arsenal convinced her the move was perfect: "From our first talk, I could sense the belief and ambition at the club—things we can achieve together. I want to push myself as far as possible, and I believe Arsenal is the ideal place for that."
Holmberg has long harbored a passion for the Gunners.</p> <p>"Playing for Arsenal has always been my dream," she said. "The environment here is fantastic for development, both as a player and as a person. My goals are to keep growing individually and, of course, to win trophies with Arsenal—that's the ultimate dream for any footballer, especially at a club like this.</p>"
<p>The young defender's arrival bolsters Arsenal's options at right-back as they pursue success in domestic and European competitions.</p> <p><b>Mandarin 中文版</b></p>

<p><b>阿森纳宣布签下瑞典新星斯米拉·霍尔姆伯格，这位19岁的后卫从哈马比加盟球队，以加强俱乐部青训体系和一线队阵容深度。这笔转会彰显了“枪手”对长期人才培养与未来发展的坚定投入。</b></p>

<p>瑞典小将斯米拉·霍尔姆伯格在与阿森纳签下一份长期合同后表示，这次转会对她来说是“梦想成真”。这位19岁的右后卫来自瑞典俱乐部哈马比IF，她在俱乐部青训体系中成长，并在年仅15岁时便完成了一线队首秀，展现出非凡潜力。</p>

<p>自那以后，霍尔姆伯格积累了丰富的比赛经验。她在2023年随队夺得瑞典联赛冠军，并在2023年和2025年两度赢得瑞典杯冠军。同时，她已代表瑞典国家队出场九次，逐渐在国际舞台上崭露头角。</p>

<p>在完成签约并获得31号球衣后，霍尔姆伯格在阿森纳官方网站上谈到了转战英格兰女子超级联赛的决定：“我觉得现在是挑战自我、走出舒适区的合适时机。”</p>

<p>她还表示，与阿森纳的初次交流便让她确信这是理想的选择：“从第一次交谈开始，我就感受到了俱乐部的信念与雄心——以及我们可以一起实现的目标。我希望把自己推向更高的高度，我相信阿森纳是实现这一目标的最佳平台。”</p>

<p>霍尔姆伯格一直对“枪手”怀有深厚情感。“为阿森纳效力一直是我的梦想，”她说道。“这里的环境无论在球员成长还是个人发展方面都非常出色。我的目标是不断提升自己，当然也希望与阿森纳一起赢得奖杯——对于任何一名足球运动员来说，尤其是在这样一家俱乐部，这都是终极梦想。”</p>

<p>这位年轻后卫的加盟为阿森纳在右后卫位置上提供了更多选择，也为球队在国内和欧洲赛场上争取荣誉增添了深度与活力。</p>
`,
            tags: ["Arsenal", "Transfers", "WSL", "Youth", "Smilla Holmberg", "Hammarby"],
            navIndices: { prev: 'wsl-2', next: 'wsl-4' }
        });
    }

    init() {
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WSL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wslnews' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) { leagueLogo.src = '/images/league_wsl.png'; leagueLogo.alt = 'WSL'; }
    }
}